import React, { useEffect,useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import styles from "./AdminDashboard.module.css";
import IBTasksProgress from "./admin/IBTasksProgress";
import MonthlyExtensionCount from "./ccm/MonthlyExtensionCount";
import AutoApprovalRate from "./ccm/AutoApprovalRate";
import { fetchIbTasksProgress } from "../../store/slices/dashboard";
import NotificationBanner from "./NotificationBanner";
import NotificationModal from "./NotificationModal";


const AdminDashboard = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchIbTasksProgress());
  }, [dispatch]);

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardHeader}>
        <h1 className={styles.dashboardTitle}>Dashboard</h1>
        <IconButton className={styles.settingsIcon} onClick={() => setIsModalOpen(true)}>
          <SettingsOutlinedIcon />
        </IconButton>
      </div>

      <NotificationBanner />

      <NotificationModal 
        open={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />

      <div className={styles.content}>
        <div className={styles.fullWidth}>
          <IBTasksProgress />
        </div>

        <div className={styles.chartsRow}>
          <div className={styles.chartCard}>
            <MonthlyExtensionCount isAdmin={true} />
          </div>
          <div className={styles.chartCard}>
            <AutoApprovalRate isAdmin={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
